enum SituacaoRemuneracaoCalculoEnum {
  Calculado = 'Calculado',
  Validado = 'Validado',
  Divergente = 'Divergente',
  Descartado = 'Descartado',
}

export default SituacaoRemuneracaoCalculoEnum
